const styles = {
  root: {
    position: 'relative',
    '&.variant': {
      pr: 2,
      pt: 0,
      pl: 0,
    },
    '&.mobile': {
      padding: 0,
    },
  },

  titleContainer: {
    px: { xs: 3, lg: 5 },
    pb: 2,
    pt: 3,
  },

  titleFilter: {
    // position: 'relative',
    width: '100%',
    '&.variant': {
      width: '100%',
    },
    '& .sticky': {
      top: '56px!important',
      backgroundColor: 'background.default',
      width: '100%',
      position: 'fixed',
    },
    display: {
      xs: 'block',
      md: 'none',
    },
  },

  stickyContainer: {
    bottom: 0,
  },

  filtersBottomContainer: {
    px: {
      xs: 1, lg: 4, xl: 4,
    },
    py: 3,
  },

  actionButtons: {
    mt: 6,
    backgroundColor: 'background.default',
    pb: 2,
  },

  titleFilterContent: {
    margin: '0 auto',
  },

  gridContainer: {
    justifyContent: 'space-between',
    gap: 0.5,
    overflowY: 'hidden!important',
    pt: { xs: 2, md: 8 },
  },

  searchTitle: {
    mb: 2,
    '&.MuiTypography-h2': {
      fontWeight: 700,
      fontSize: 25,
      lineHeight: '25px',
      color: 'primary.main',
    },
  },

  leftSideContainer: {
    backgroundColor: 'background.default',
    // backgroundColor: 'red',
    overflowY: 'scroll!important',
    '& .sticky': {
      pt: '56px!important',
      overflowY: 'scroll!important',
      height: '100vh',
    },
    display: {
      xs: 'none',
      md: 'block',
    },
  },
  mobileFilter: {
    mb: 2,
    display: 'flex',
    gap: 1,
    flexWrap: 'nowrap',
    overflowX: 'scroll',
  },

  listContainer: {
    padding: 2,
    backgroundColor: { xs: 'background.default', lg: 'unset' },
  },

  mobileModal: {
    '& .MuiDialog-container': {
      alignItems: 'flex-end!important',
    },
    '& .MuiPaper-root': {
      height: '70%',
    },
  },

  displayMobile: {
    display: { xs: 'block', md: 'none' },
  },
  displayDesktop: {
    display: { xs: 'none', md: 'block' },
  },

  scrollTopContainer: {
    position: 'fixed',
    right: '4px',
    bottom: '4px',
    zIndex: 99,
    opacity: 0,
    visibility: 'hidden',
    transform: 'translateY(20px)',
    '&.visible': {
      visibility: 'visible',
      transform: 'translateY(0)',
      transition: 'opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease',
      opacity: 1,
    },
  },

  scrollTop: {
    '&.MuiIconButton-root': {
      backgroundColor: 'secondary.main',
      color: 'text.white',
      borderRadius: '12px!important',
    },
  },

  /**
   * Banner promocional del SRP (solo con el ordenamiento por descuento).
   *
   * `lineHeight: 0` evita el hueco de unos pixeles que el navegador deja debajo
   * de una imagen en linea, que se notaria como un margen extra antes del
   * listado. El `img` a 100%/auto es lo que hace que ocupe todo el ancho de su
   * columna del grid y conserve la proporcion en cualquier breakpoint.
   */
  discountBanner: {
    mb: 2,
    borderRadius: 1,
    overflow: 'hidden',
    lineHeight: 0,
    '& img': {
      width: '100%',
      height: 'auto',
      display: 'block',
    },
  },

}

export default styles
